<!-- BEGIN: Horizontal Menu -->
<button class="kt-header-menu-wrapper-close" id="kt_header_menu_mobile_close_btn">
  <i class="la la-close"></i>
</button>
<div ktOffcanvas [options]="offcanvasOptions" class="kt-header-menu-wrapper" id="kt_header_menu_wrapper">
  <div id="kt_header_menu" ktMenu [options]="menuOptions" class="kt-header-menu kt-header-menu-mobile ">
    <ul class="kt-menu__nav">
      <li  class="kt-menu__item kt-menu__item--submenu" aria-haspopup="true"
        data-ktmenu-submenu-toggle="hover">
        @if (isMobileDevice()) {
          <menu-search-bar></menu-search-bar>
        }
      </li>
      @for (item of menu.items; track item) {
        @if (item.name) {
          <ng-container [ngTemplateOutlet]="kt_menu"
            [ngTemplateOutletContext]="{ item: item, depth: 0 }">
          </ng-container>
        }
      }
    </ul>
  </div>
  <div class="kt-header-toolbar">
    @if (!isMobileDevice()) {
      <menu-search-bar></menu-search-bar>
    }
  </div>
</div>
<!-- END: Horizontal Menu -->


<ng-template #kt_menu let-item="item" let-parentItem="parentItem" let-depth="depth">
  @if (showMenuItem(item)) {
    <li attr.aria-haspopup="true" (mouseleave)="mouseLeave($event)" (mouseenter)="mouseEnter($event)"
      data-ktmenu-submenu-toggle="click" class="{{ getItemCssClasses(item, parentItem, depth) }}"
      routerLinkActive="kt-menu__item--active"><!-- NOSONAR -->
      <!-- if item has submenu -->
      @if (item.items.length || (isTabMenuUsed && !parentItem && !item.items.length)) {
        <a href="javascript:;" class="{{ getAnchorItemCssClasses(item, parentItem) }}">
          <ng-container [ngTemplateOutlet]="kt_menu_item_inner"
            [ngTemplateOutletContext]="{ item: item, parentItem: parentItem, depth: (depth + 1) }">
          </ng-container>
          <!-- arrow icons -->
          <!-- <i *ngIf="currentTheme.baseSettings.header.headerMenuArrows && item.items.length && !parentItem"
        class="kt-menu__hor-arrow la la-angle-down"></i> -->
        <!-- <i *ngIf="item.items.length && !parentItem" class="kt-menu__ver-arrow la la-angle-right"></i> -->
        <!-- else arrow icons -->
        <!-- <i *ngIf="currentTheme.baseSettings.header.headerMenuArrows && item.items.length && parentItem"
      class="kt-menu__hor-arrow la la-angle-right"></i> -->
      <!-- <i *ngIf="item.items.length && parentItem" class="kt-menu__ver-arrow la la-angle-right"></i> -->
    </a>
  }
  <!-- if item hasn't sumbenu -->
  @if (!item.items.length && !(isTabMenuUsed && !parentItem && !item.items.length)) {
    @if (!item.external) {
      <a [routerLink]="item.route" [queryParams]="item.parameters" class="kt-menu__link">
        <ng-container [ngTemplateOutlet]="kt_menu_item_inner"
          [ngTemplateOutletContext]="{ item: item, parentItem: parentItem, depth: (depth + 1) }">
        </ng-container>
      </a>
    }
    @if (item.external) {
      <a [attr.href]="[item.route]" target="_blank" class="kt-menu__link">
        <ng-container [ngTemplateOutlet]="kt_menu_item_inner"
          [ngTemplateOutletContext]="{ item: item, parentItem: parentItem, depth: (depth + 1) }">
        </ng-container>
      </a>
    }
  }
  <!-- if menu item has submenu child then recursively call new menu item component -->
  @if (item.items.length) {
    <div class="{{ getSubmenuCssClasses(item, parentItem, depth) }}">
      <span class="kt-menu__arrow" [ngClass]="{ 'kt-menu__arrow--adjust': !parentItem }"></span>
      @if (item.items.length) {
        <ul class="kt-menu__subnav">
          @for (child of item.items; track child) {
            <ng-container [ngTemplateOutlet]="kt_menu"
              [ngTemplateOutletContext]="{ item: child, parentItem: item, depth: (depth + 1) }">
            </ng-container>
          }
        </ul>
      }
    </div>
  }
  @if (isTabMenuUsed && !parentItem && !item.items.length) {
    <div class="kt-menu__submenu kt-menu__submenu--classic kt-menu__submenu--left"
      [ngClass]="{'kt-menu__submenu--tabs': isTabMenuUsed}">
      <span class="kt-menu__arrow" [ngClass]="{ 'kt-menu__arrow--adjust': !parentItem }"></span>
      <ul class="kt-menu__subnav">
        <ng-container [ngTemplateOutlet]="kt_menu"
          [ngTemplateOutletContext]="{ item: item, parentItem: item, depth: (depth + 1) }">
        </ng-container>
      </ul>
    </div>
  }
</li>
}
</ng-template>

<!-- item inner -->
<ng-template #kt_menu_item_inner let-item="item" let-parentItem="parentItem">
  <!-- if menu item has icon -->
  <!-- <i *ngIf="item.icon" class="kt-menu__link-icon" [ngClass]="item.icon"></i> -->

  <ng-container>
    <!-- <span class="kt-menu__item-here"></span> -->
    <!-- menu item title text -->
    <span class="kt-menu__link-text">
      {{item.name | localize}}
    </span>
  </ng-container>
</ng-template>
